import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { FiEye, FiEyeOff, FiKey } from 'react-icons/fi';
import axiosInstance from '../../utils/axiosInstance';
import { useSession } from '../../context/SessionContext';
import { Button } from '../../components/ui/Button';
import { Card } from '../../components/ui/Card';
import { FormField, inputClassName } from '../../components/ui/FormField';
import { PageHeader } from '../../components/ui/PageHeader';

export const ChangePassword = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updateSessionUser } = useSession();
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const currentPassword = form.elements.currentPassword.value;
    const newPassword = form.elements.newPassword.value;
    const confirmPassword = form.elements.confirmPassword.value;
    if (newPassword !== confirmPassword) return toast.error(t('Passwords do not match'));
    setSubmitting(true);
    try {
      const response = await axiosInstance('/user/change-password', 'post', { currentPassword, newPassword });
      if (!response || response.status >= 400) return toast.error(t(response?.data?.message || 'Unable to change password.'));
      updateSessionUser(response.data.user);
      toast.success(t('Password changed successfully.'));
      navigate('/dashboard', { replace: true });
    } finally { setSubmitting(false); }
  };

  return <div className='mx-auto max-w-2xl'>
    <PageHeader title={t('Choose a private password')} description={t('Your temporary password must be replaced before continuing.')} />
    <Card className='p-5 sm:p-7'>
      <div className='mb-5 flex items-start gap-3 border-b border-[var(--border-subtle)] pb-5'><span className='flex h-11 w-11 items-center justify-center rounded-[var(--radius-md)] bg-[var(--brand-soft)] text-[var(--brand)]'><FiKey /></span><div><h2 className='font-bold'>{t('Protect your account')}</h2><p className='mt-1 text-sm text-[var(--text-secondary)]'>{t('Only you should know the new password.')}</p></div></div>
      <form className='space-y-4' onSubmit={submit}>
        <FormField label={t('Current password')} required><input name='currentPassword' type={showPassword ? 'text' : 'password'} autoComplete='current-password' className={inputClassName} required /></FormField>
        <FormField label={t('New Password')} required><input name='newPassword' type={showPassword ? 'text' : 'password'} autoComplete='new-password' className={inputClassName} required /></FormField>
        <FormField label={t('Confirm Password')} required><input name='confirmPassword' type={showPassword ? 'text' : 'password'} autoComplete='new-password' className={inputClassName} required /></FormField>
        <label className='flex items-center gap-2 text-sm text-[var(--text-secondary)]'><input type='checkbox' checked={showPassword} onChange={(event) => setShowPassword(event.target.checked)} />{showPassword ? <FiEyeOff /> : <FiEye />}{t(showPassword ? 'Hide passwords' : 'Show passwords')}</label>
        <p className='text-xs text-[var(--text-muted)]'>{t('Use at least 8 characters with uppercase, lowercase, number, and symbol.')}</p>
        <Button type='submit' variant='primary' loading={submitting} className='w-full'>{t('Change password and continue')}</Button>
      </form>
    </Card>
  </div>;
};
